(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription"] && !Shopify.designMode) return;
  try {
    
// Form animation and validation
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('bloom-subscription-form');
  
  if (form) {
    form.addEventListener('submit', function(e) {
      const submitBtn = form.querySelector('.bloom-submit-btn');
      submitBtn.style.opacity = '0.6';
      submitBtn.textContent = 'Submitting...';
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
